import { render, staticRenderFns } from "./ProteinGlucidesLipidesBar.vue?vue&type=template&id=89277a06&scoped=true"
import script from "./ProteinGlucidesLipidesBar.vue?vue&type=script&lang=js"
export * from "./ProteinGlucidesLipidesBar.vue?vue&type=script&lang=js"
import style0 from "./ProteinGlucidesLipidesBar.vue?vue&type=style&index=0&id=89277a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89277a06",
  null
  
)

export default component.exports